module.exports = __webpack_public_path__ + "static/media/YF31_4.002eacf5.jpg";